// extracted by mini-css-extract-plugin
export default {"container":"CoursesIndicators_container__GTmA2"};